import React, { useEffect, useRef, useState, useCallback, memo } from 'react'
import PreviewOrderModal from '../../../../components/PreviewOrderModal';
import { SearchIcon } from '@chakra-ui/icons';
import { Box, Flex, Text, Stack, Tabs, Button, TabList, TabPanels, Tab, TabPanel, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Avatar, Badge, IconButton, Input, InputGroup, InputLeftElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Skeleton, SkeletonCircle, Switch, Table, TableCaption, TableContainer, Tbody, Td, Tfoot, Th, Thead, Tr, useColorModeValue, useDisclosure, useToast, BreadcrumbItem, BreadcrumbLink, Breadcrumb, Tooltip, FormControl, FormLabel, SimpleGrid, Card, CardBody, Image, Heading, Portal, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody, InputRightElement, CloseButton, Checkbox, Menu, MenuItem, MenuList, MenuButton } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStateContext } from '../../../../context/ContextProvider';
import axiosClient from '../../../../axios-client';
import { TbListDetails } from 'react-icons/tb';
import MyPagination from '../../../../components/MyPagination';
import { RiFileExcel2Fill, RiFileTransferLine, RiUserShared2Line } from 'react-icons/ri';
import { CiMenuKebab } from 'react-icons/ci';
import BulkStatusUpdateModal from '../../../../components/BulkStatusUpdateModal';
import { FaRegEye } from 'react-icons/fa6';
import { AsyncPaginate } from 'react-select-async-paginate';
import { DateRange } from 'react-date-range';
import format from 'date-fns/format';
import fr from 'date-fns/locale/fr';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { usePersistedListState, useScrollRestore } from '../../../../hooks/usePersistedListState';
import { useDebounce } from '../../../../hooks/useDebounce';
import GestStockOrderRow from '../../../../components/Tables/GestStockOrderRow';
import { GrPowerReset } from 'react-icons/gr';

let isFirstLoad_GestStock = true;
function GestStock() {
  const { user, setUser, setToken, currentBusiness } = useStateContext()
  const navigate = useNavigate()
  const { t } = useTranslation();
  const toast = useToast()


  const [statusStock, setStatusStock] = useState('')

  const [isBulkSubmitting, setIsBulkSubmitting] = useState(false);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

  const [dataOrder, setDataOrder] = useState([])
  const [paginationData, setPaginationData] = useState()
  const [loading, setLoading] = useState(true)


  const {
    currentPage, setCurrentPage,
    pageSize, setPageSize,
    searchTerm, setSearchTerm,
    userSelected, setUserSelected,
    statusSelected, setStatusSelected,
    dateDebutValue, setDateDebutValue,
    dateFinValue, setDateFinValue,
    selectedProduct, setSelectedProduct,
    saveScrollPosition
  } = usePersistedListState('GestStock');
  const tableRef = useRef(null);
  useScrollRestore('GestStock', loading, tableRef);

  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const bgPurple = useColorModeValue('purple.100', 'purple.900');

  const [selectedRows, setSelectedRows] = useState([]);

  const handleCheckboxClick = useCallback((index) => {
    setSelectedRows(prev => {
      const selectedIndex = prev.indexOf(index);
      if (selectedIndex === -1) {
        return [...prev, index];
      } else {
        return prev.filter((rowIndex) => rowIndex !== index);
      }
    });
  }, []);

  const handleSelectAll = useCallback((e) => {
    if (e.target.checked) {
      setSelectedRows(dataOrder.map(order => order.id));
    } else {
      setSelectedRows([]);
    }
  }, [dataOrder]);

  const assign_order_to = async (assignToId) => {
    if (selectedRows.length === 0) return;
    if (isBulkSubmitting) return;
    setIsBulkSubmitting(true);
    try {
      await axiosClient.post('/commandes/bulk_actions/', {
        action: 'assign_orders',
        user_id: assignToId,
        order_ids: selectedRows
      });
      toast({
        description: t("Commandes attribuées avec succès"),
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right'
      });
      setSelectedRows([]);
      const abortController = new AbortController();
      fetchData(abortController.signal);
    } catch (error) {
      toast({
        description: t("Erreur lors de l'attribution"),
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right'
      });
    } finally {
      setIsBulkSubmitting(false);
    }
  };

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  const handleSelectDateRange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectionRange(ranges.selection);
    setDateDebutValue(format(startDate, 'yyyy-MM-dd'));
    setDateFinValue(format(endDate, 'yyyy-MM-dd'));
  };

  const clearDateRange = () => {
    setDateDebutValue("");
    setDateFinValue("");
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    });
  };



  const selectTextColor = useColorModeValue('black', 'white'); // trigger rebuild
  const selectBg = useColorModeValue('transparent', 'transparent');
  const selectMenuBg = useColorModeValue('white', '#2D3748');
  const selectBorderColor = useColorModeValue('#E2E8F0', 'rgba(255, 255, 255, 0.16)');
  const selectHoverBg = useColorModeValue('#EDF2F7', '#4A5568');

  const loadProductOptions = async (search, loadedOptions, { page }) => {
    try {
      const res = await axiosClient.get(`/products/get_All_Products_names/?client=${user?.id}&page_size=20&page=${page}&search_term=${search}&userRole=${user?.role}&business=${currentBusiness?.id}`, { hideLoader: true });
      const results = res.data.results || [];
      const hasMore = res.data.next !== null && res.data.next !== undefined;
      return {
        options: results.map(product => ({ value: product.id, label: product.title })),
        hasMore,
        additional: { page: page + 1 },
      };
    } catch (error) {
      // // console.error('Error fetching products', error);
      return { options: [], hasMore: false };
    }
  };

  // PAGINATION

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(0);
  };

  const fetchData = useCallback(async (signal) => {
    try {
      setLoading(true)
      const res = await axiosClient.get(`/commandes/getStockOrder/?clientId=${user.id}&page_size=${pageSize}&page=${currentPage + 1}&search_term=${debouncedSearchTerm}&statusSelected=${statusSelected}&dateDebut=${dateDebutValue}&dateFin=${dateFinValue}&product=${selectedProduct ? selectedProduct.value : ''}&business=${currentBusiness?.id}`, { signal, hideLoader: !isFirstLoad_GestStock });
      isFirstLoad_GestStock = false;
      // if (user.role === ('AdminClient')) {
      //     setDataOrder(res.data.filter(e => e.client === user.id && e.is_deleted === false && e.assigned_to !== null && e.assigned_to_stock === null && e.assigned_to_suivi === null))
      // }
      // else if (user.role === ('ManagerClient')) {
      //     setDataOrder(res.data.filter(e => e.client === user.works_for && e.is_deleted === false && e.assigned_to !== null && e.assigned_to_stock === null && e.assigned_to_suivi === null))
      // }
      // else {
      //     setDataOrder(res.data.filter(e => e.assigned_to === user.id && e.is_deleted === false))
      // }
      // console.log('RESULTS DATA : ', res.data.results);
      if (res.data.length !== 0) {
        setDataOrder(res.data.results)
        setPaginationData(res.data)
      } else {
        setDataOrder([])
        setPaginationData([])
      }

      if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
        setUser({});
        setToken(null);
        localStorage.removeItem("tokenExpirationTime");
        localStorage.removeItem("refreshTimeAdmin");
        localStorage.removeItem("role");

        // Vérifier si le toast n'est pas déjà affiché
        if (!toast.isActive('accountDisabled')) {
          toast({
            id: 'accountDisabled',
            description: t("le compte est désactivé"),
            status: 'warning',
            variant: 'left-accent',
            duration: 2000,
            isClosable: true,
            position: 'bottom-right'
          });
        }
      }
      setLoading(false)
    } catch (error) {
      if (error.name !== 'CanceledError' && error.message !== 'canceled') {
        setLoading(false)
      }
      // console.log('ERROR : ', error);
    }
  }, [user?.id, currentPage, debouncedSearchTerm, pageSize, statusSelected, dateDebutValue, dateFinValue, selectedProduct, currentBusiness?.id]);

  useEffect(() => {
    if (user?.id) {
      const abortController = new AbortController();
      fetchData(abortController.signal);
      return () => abortController.abort();
    }
  }, [fetchData])

  // Update status

  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [isExportAlertOpen, setIsExportAlertOpen] = useState(false);
  const cancelRef = React.useRef()
  const [statusId, setStatusId] = useState()

  const onOpenAlert = (id) => {
    setIsAlertOpen(true);
    setStatusId(id)
  };
  const onCloseAlert = () => {
    setIsAlertOpen(false);
    setStatusStock('')
    setStatusId()
  };
  const onOpenExportAlert = () => setIsExportAlertOpen(true);
  const onCloseExportAlert = () => setIsExportAlertOpen(false);

  const HandleChangeStatus = async () => {
    if (isUpdatingStatus) return;
    setIsUpdatingStatus(true);
    try {
      await axiosClient.patch(`commandes/${statusId}/`, {
        status_stock: statusStock
      }).then((res) => {
        setDataOrder(prevData => prevData.map((item) => {
          if (item.id === res.data.id) {
            return {
              ...item,
              status_stock: res.data.status_stock
            }
          }
          return item
        }))
        onCloseAlert()
        toast({
          description: t(`Statut est changé avec succès`),
          status: 'success',
          duration: 2000,
          isClosable: true,
          variant: 'left-accent',
          position: 'bottom-right'
        })
      })
    } catch (error) {
      // console.log('ERROR : ', error);
    } finally {
      setIsUpdatingStatus(false);
    }
  }

  const borderColor = useColorModeValue("gray.300", "gray.600")
  const textSM = useColorModeValue('gray.400', 'gray.500');
  const selectedRowBg = useColorModeValue('purple.50', 'gray.600');
  const bgStack = useColorModeValue('white', 'gray.700')

  const resetFilters = () => {
    setSearchTerm('');
    setStatusSelected('');
    clearDateRange();
    setSelectedProduct(null);
    setCurrentPage(0);
  };

  const handleExportExcel = async () => {
    try {
      // Configurer la requête pour recevoir un Blob
      const response = await axiosClient.get(`export-orders/${user?.id}/`, {
        responseType: 'blob',
      });

      if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
        setUser({});
        setToken(null);
        localStorage.removeItem("tokenExpirationTime");
        localStorage.removeItem("refreshTimeAdmin");
        localStorage.removeItem("role");

        // Vérifier si le toast n'est pas déjà affiché
        if (!toast.isActive('accountDisabled')) {
          toast({
            id: 'accountDisabled',
            description: t("le compte est désactivé"),
            status: 'warning',
            variant: 'left-accent',
            duration: 2000,
            isClosable: true,
            position: 'bottom-right'
          });
        }
        return;
      }

      // Créer un objet URL à partir du Blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Créer un lien pour télécharger le fichier
      const link = document.createElement('a');
      link.href = url;

      // Nom du fichier
      link.setAttribute('download', 'commandes_en_cours.xlsx'); // Vous pouvez changer le nom du fichier ici
      document.body.appendChild(link);
      link.click();

      // Supprimer le lien une fois le téléchargement terminé
      link.parentNode.removeChild(link);

      toast({
        description: t("Le fichier a été exporté avec succès."),
        variant: 'left-accent',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right'
      });
    } catch (error) {
      // // console.error('Une erreur s\'est produite lors de l\'exportation du fichier!', error);
      toast({
        description: t("Une erreur s'est produite lors de l'exportation du fichier."),
        variant: 'left-accent',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right'
      });
    }
  }

  //vider l'input de date fin
  useEffect(() => {
    if (!dateDebutValue) {
      // Si dateDebutValue est vide, on réinitialise dateFinValue
      setDateFinValue('');
    } else if (dateFinValue && dateDebutValue >= dateFinValue) {
      // Si dateDebutValue est supérieur ou égal à dateFinValue, on réinitialise dateFinValue
      setDateFinValue('');
    }
  }, [dateDebutValue, dateFinValue]);

  // Aperçu Commande
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewId, setPreviewId] = useState(null);

  const onOpenPreview = (id) => {
    setPreviewId(id);
    setIsPreviewOpen(true);
  };

  const onClosePreview = () => {
    setIsPreviewOpen(false);
    setPreviewId(null);
  };

  return (
    <Box mt="5px">

      <Flex>
        <Box w="90%" mt={2} mb={5}>
          <Breadcrumb fontStyle={"normal"} fontSize={{ base: "14px", sm: "14px", lg: "15px" }} color="gray.400" letterSpacing="-0.01em">
            <BreadcrumbItem>
              <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink>{t("Gestion stock")}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Box>
      </Flex>

      <Flex
        px={2}
        py={5}
        mx={5}
        bg={bgStack}
        rounded={"2xl"}
        mt={2}
        align={'center'}
        justify={'center'}

      >

        <Stack
          w={'full'}
          maxW='full'
          rounded={'lg'}
          mt={2}
          px={{ base: 1, md: 5 }}
        >
          {/* Search input */}
          <Flex align="center" gap={3} w="full" direction={{ base: 'column', lg: 'row' }} justify="space-between" mb={6}>
            <Flex gap={3} w="full" direction={{ base: 'column', md: 'row' }} flexWrap="wrap">
              <Flex w={{ base: '100%', md: '300px' }} gap={statusSelected === 'En cours' ? 3 : 0}>
                <Select
                  borderColor={borderColor}
                  borderRadius="xl"
                  size="md"
                  fontSize={{ base: 13, lg: 16 }}
                  w={'100%'}
                  value={statusSelected}
                  onChange={(e) => {
                    setCurrentPage(0)
                    setStatusSelected(e.target.value)
                  }}
                >
                  <option value=''>{t('Statut de stock')}</option>
                  <option value='Nouveau'>{t('Nouveau')}</option>
                  <option value='Épuisé'>{t('Épuisé')}</option>
                  <option value='Annulé'>{t('Annulé')}</option>
                  <option value='En cours'>{t('En cours')}</option>
                  <option value='Emballé'>{t('Emballé')}</option>
                  <option value='Collecté'>{t('Collecté')}</option>
                </Select>

                {statusSelected === 'En cours' &&
                  <Tooltip label={t('Télécharger le fichier excel')}>
                    <IconButton
                      icon={<RiFileExcel2Fill />}
                      colorScheme='green'
                      variant='outline'
                      onClick={onOpenExportAlert}
                      rounded="xl"
                      aria-label={t("Export Excel")}
                    />
                  </Tooltip>
                }
              </Flex>

              <Box w={{ base: '100%', md: '200px' }}>
                <AsyncPaginate
                  loadOptions={loadProductOptions}
                  onChange={(option) => {
                    setCurrentPage(0);
                    setSelectedProduct(option);
                  }}
                  value={selectedProduct}
                  isClearable
                  placeholder={t('Produit...')}
                  noOptionsMessage={() => t('Aucun produit trouvé')}
                  additional={{ page: 1 }}
                  styles={{
                    control: (p) => ({ ...p, backgroundColor: selectBg, borderColor: selectBorderColor, color: selectTextColor, minHeight: '40px', borderRadius: '12px' }),
                    menu: (p) => ({ ...p, zIndex: 9999, backgroundColor: selectMenuBg, borderRadius: '12px' }),
                    option: (p, s) => ({ ...p, backgroundColor: s.isFocused ? selectHoverBg : 'transparent', color: selectTextColor }),
                    singleValue: (p) => ({ ...p, color: selectTextColor }),
                    input: (p) => ({ ...p, color: selectTextColor }),
                  }}
                />
              </Box>

              <Box w={{ base: '100%', md: '250px' }}>
                <Popover placement="bottom-start">
                  <PopoverTrigger>
                    <InputGroup size="md">
                      <Input
                        readOnly
                        value={dateDebutValue ? `${dateDebutValue} ${t("au")} ${dateFinValue}` : t("Choisir une période")}
                        cursor="pointer"
                        rounded="xl"
                        borderColor={borderColor}
                        bg={useColorModeValue('white', 'gray.700')}
                        _hover={{ borderColor: 'purple.400' }}
                        _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                      />
                      {dateDebutValue && (
                        <InputRightElement w="auto" pr={2}>
                          <IconButton
                            variant="ghost"
                            size="sm"
                            icon={<CloseButton size="sm" />}
                            onClick={(e) => {
                              e.stopPropagation();
                              clearDateRange();
                            }}
                            aria-label={t("Effacer la date")}
                          />
                        </InputRightElement>
                      )}
                    </InputGroup>
                  </PopoverTrigger>
                  <Portal>
                    <PopoverContent w="auto" p={0} border="none" shadow="2xl" zIndex={9999}>
                      <PopoverArrow />
                      <PopoverBody p={0}>
                        <DateRange
                          ranges={[selectionRange]}
                          onChange={handleSelectDateRange}
                          locale={fr}
                          maxDate={new Date()}
                          rangeColors={['#805AD5']}
                        />
                      </PopoverBody>
                    </PopoverContent>
                  </Portal>
                </Popover>
              </Box>

              <InputGroup size="md" w={{ base: '100%', md: '200px' }}>
                <InputLeftElement pointerEvents='none'>
                  <SearchIcon color="gray.400" />
                </InputLeftElement>
                <Input
                  borderColor={borderColor}
                  borderRadius="xl"
                  placeholder={t("Recherche...")}
                  value={searchTerm}
                  onChange={(e) => {
                    setCurrentPage(0)
                    setSearchTerm(e.target.value)
                  }}
                  _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                />
              </InputGroup>

              <IconButton
                icon={<GrPowerReset />}
                onClick={resetFilters}
                variant="outline"
                colorScheme="purple"
                rounded="xl"
                aria-label={t("Réinitialiser")}
                title={t("Réinitialiser les filtres")}
              />
            </Flex>
          </Flex>

          {selectedRows.length > 0 && (
            <Flex position="sticky" top="0" zIndex="20"
              mb={2}
              gap={{ base: 2, md: 3 }}
              w="100%"
              align={{ base: 'flex-start', md: 'center' }}
              bg={bgPurple}
              p={3}
              rounded="md"
              direction={{ base: 'column', sm: 'row' }}
              flexWrap="wrap"
            >
              <Text fontWeight="bold" whiteSpace="nowrap">
                {selectedRows.length} {t("sélectionné(s)")}
              </Text>

              <Flex gap={2} flexWrap="wrap" align="center">
                {user?.role !== 'LIVREUR' && (
                  <Button size="sm" colorScheme="purple" isLoading={isBulkSubmitting} onClick={() => assign_order_to(user.id)}>
                    <RiUserShared2Line style={{ marginRight: '5px' }} />
                    {t("M'attribuer")}
                  </Button>
                )}
                <BulkStatusUpdateModal
                  statusField="status_stock"
                  statusKey="status_stock"
                  statusOptions={[
                    { value: 'Nouveau', label: 'Nouveau' },
                    { value: 'Épuisé', label: 'Épuisé' },
                    { value: 'Annulé', label: 'Annulé' },
                    { value: 'En cours', label: 'En cours' },
                    { value: 'Emballé', label: 'Emballé' },
                    { value: 'Collecté', label: 'Collecté' },
                  ]}
                  selectedRows={selectedRows}
                  dataList={dataOrder}
                  onSuccess={(newStatus) => {
                    if (newStatus) {
                      setDataOrder(prev => prev.map(item =>
                        selectedRows.includes(item.id)
                          ? { ...item, status_stock: newStatus }
                          : item
                      ));
                    }
                    setSelectedRows([]);
                  }}
                />

                {user?.role !== 'LIVREUR' && (
                  <Button size="sm" colorScheme="blue" isLoading={isBulkSubmitting} onClick={async () => {
                    if (isBulkSubmitting) return;
                    setIsBulkSubmitting(true);
                    try {
                      const res = await axiosClient.post(`/commandes/bulk_actions/`, {
                        action: 'send_to_shipping',
                        user_id: user.id,
                        order_ids: selectedRows
                      });
                      const abortController = new AbortController();
                      fetchData(abortController.signal);
                      const results = res.data.results || [];
                      const errors = results.filter(r => !r.success);
                      const successes = results.filter(r => r.success);
                      
                      if (successes.length > 0) {
                        toast({
                          description: `${successes.length} commande(s) envoyée(s) au transporteur avec succès.`,
                          status: 'success',
                          duration: 3000,
                          isClosable: true,
                          position: 'bottom-right'
                        });
                      }

                      if (errors.length > 0) {
                        errors.forEach(err => {
                          toast({
                            description: `Erreur - Commande ${err.order_code}: ${err.message}`,
                            status: 'error',
                            duration: 5000,
                            isClosable: true,
                            position: 'bottom-right'
                          });
                        });
                      }
                      setSelectedRows([]);
                    } catch (err) {
                      toast({
                        description: t("Erreur lors de l'envoi au transporteur"),
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                        position: 'bottom-right'
                      });
                    } finally {
                      setIsBulkSubmitting(false);
                    }
                  }}>
                    <RiFileTransferLine style={{ marginRight: '5px' }} />
                    {t("Envoyer au transporteur")}
                  </Button>
                )}
              </Flex>
            </Flex>
          )}

          <TableContainer ref={tableRef} maxH={selectedRows.length > 0 ? "calc(100vh - 180px)" : "calc(100vh - 80px)"} overflowY="auto" mx={{ base: -3, md: -7 }}>
            <Table size={{ base: 'sm', md: 'md' }} variant='simple' style={{ borderCollapse: "separate", borderSpacing: 0 }}>
              <Thead>
                <Tr>
                  <Th borderBottomColor='gray.400' position="sticky" left={0} top={0} zIndex={4} bg="white" _dark={{ bg: "gray.700" }}>
                    <Checkbox
                      size="md"
                      colorScheme='purple'
                      onChange={handleSelectAll}
                      isChecked={selectedRows.length === dataOrder.length && dataOrder.length > 0}
                    />
                  </Th>
                  <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("#ID")}</Th>
                  <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Client")}</Th>
                  <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Adresse")}</Th>
                  <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("téléphone")}</Th>
                  <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Status")}</Th>
                  <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Coupons")}</Th>
                  <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Prix")}</Th>
                  <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Date Création")}</Th>
                  <Th borderBottomColor='gray.400' position="sticky" top={0} zIndex={3} bg="white" _dark={{ bg: "gray.700" }}>{t("Date Modification")}</Th>
                  <Th borderBottomColor='gray.400' position="sticky" right={0} top={0} zIndex={4} bg="white" _dark={{ bg: "gray.700" }}>{t("Options")}</Th>
                </Tr>
              </Thead>
              <Tbody>

                {loading &&
                  <Tr>
                    <Td><Skeleton h={5} w={5} /></Td>
                    <Td><Skeleton h={10} w={10} /></Td>
                    <Td><Skeleton height='20px' /></Td>
                    <Td>
                      <Flex flexDirection={"column"} gap={2}>
                        <Skeleton height='20px' />
                        <Skeleton height='10px' />
                      </Flex>
                    </Td>
                    <Td>
                      <Flex flexDirection={"column"} gap={2}>
                        <Skeleton height='20px' />
                        <Skeleton height='10px' />
                        <Skeleton height='10px' />
                      </Flex>
                    </Td>
                    <Td><Skeleton height='20px' /></Td>
                    <Td><Skeleton height='20px' /></Td>
                    <Td><Skeleton height='20px' /></Td>
                    <Td><Skeleton height='20px' /></Td>
                    <Td><Skeleton height='20px' /></Td>
                  </Tr>
                }
                {
                  dataOrder.length > 0 ?
                    dataOrder.map((val, key) => {
                      const isSelected = selectedRows.includes(val.id);
                      return (
                        <GestStockOrderRow
                          key={val.id}
                          val={val}
                          isSelected={isSelected}
                          selectedRowBg={selectedRowBg}
                          handleCheckboxClick={handleCheckboxClick}
                          saveScrollPosition={saveScrollPosition}
                          tableRefCurrent={tableRef.current}
                          navigate={navigate}
                          textSM={textSM}
                          currentBusiness={currentBusiness}
                          t={t}
                          onOpenAlert={onOpenAlert}
                          onOpenPreview={onOpenPreview}
                        />
                      )
                    })
                    :
                    <Tr>
                      <Td colSpan={6}>
                        <Text fontSize={18}>{t("Donnée introuvable")}</Text>
                      </Td>
                    </Tr>
                }
              </Tbody>
            </Table>
          </TableContainer>

          {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
          <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
            <Box flex="1">
              <MyPagination
                paginationData={paginationData}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                PAGE_SIZE={pageSize}
              />
            </Box>

            <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange}>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </Flex >
          {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}

        </Stack >


        {/* Alert to Update confirmation status */}

        < AlertDialog
          isOpen={isAlertOpen}
          leastDestructiveRef={cancelRef}
          onClose={onCloseAlert}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                {t('Statut de stock')}
              </AlertDialogHeader>

              <AlertDialogBody>
                <Text>
                  {t('Ici, vous pouvez modifier le statut de stock.')}
                </Text>

                <Select
                  mt={3}
                  rounded='lg'
                  size={"sm"}
                  value={statusStock}
                  onChange={e => setStatusStock(e.target.value)}
                >
                  <option value=''>{t('Statut de stock')}</option>
                  <option value='Épuisé'>{t('Épuisé')}</option>
                  <option value='Annulé'>{t('Annulé')}</option>
                  <option value='En cours'>{t('En cours')}</option>
                  <option value='Emballé'>{t('Emballé')}</option>
                  <option value='Collecté'>{t('Collecté')}</option>
                </Select>
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button colorScheme='yellow' size="sm" variant='outline' isLoading={isUpdatingStatus} isDisabled={!statusStock || isUpdatingStatus} mr={3} onClick={HandleChangeStatus}>{t("Modifier")}</Button>
                <Button onClick={onCloseAlert} isDisabled={isUpdatingStatus} size="sm">{t("Annuler")}</Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>

        <AlertDialog isOpen={isExportAlertOpen} leastDestructiveRef={cancelRef} onClose={onCloseExportAlert}>
          <AlertDialogOverlay backdropFilter="blur(3px)">
            <AlertDialogContent rounded="2xl">
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                {t("Confirmer l'exportation")}
              </AlertDialogHeader>
              <AlertDialogBody>
                {t("Attention : l'exportation Excel dépendra des filtres actuellement appliqués sur la page. Voulez-vous continuer ?")}
              </AlertDialogBody>
              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={onCloseExportAlert}>{t("Annuler")}</Button>
                <Button colorScheme="green" onClick={() => { onCloseExportAlert(); handleExportExcel(); }} ml={3}>{t("Exporter")}</Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Flex >


      {/* Preview Order */}
      < PreviewOrderModal
        isOpen={isPreviewOpen}
        onClose={onClosePreview}
        orderId={previewId}
      />

    </Box >
  )
}

export default GestStock